import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class DeveloperAuthService {
  private readonly DEVELOPER_PASSWORD = 'kural777';
  private readonly SESSION_KEY = 'molhy_dev_access';

  constructor(
    private alertController: AlertController,
    private toastController: ToastController
  ) {}

  isPasswordVerified(): boolean {
    return sessionStorage.getItem(this.SESSION_KEY) === 'verified';
  }

  async checkDeveloperAccess(): Promise<boolean> {
    // Check if password was already verified in this session
    if (this.isPasswordVerified()) {
      return true;
    }

    // Show password prompt
    return await this.presentPasswordAlert();
  }

  private async presentPasswordAlert(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.alertController.create({
        header: '🔐 BETA Testers Only',
        message: 'Limited access: Exclusive trial version',
        inputs: [
          {
            name: 'password',
            type: 'password',
            placeholder: 'Password',
            cssClass: 'modern-input'
          }
        ],
        buttons: [
          {
            text: 'Enter',
            cssClass: 'modern-button',
            handler: (data) => {
              if (data.password === this.DEVELOPER_PASSWORD) {
                sessionStorage.setItem(this.SESSION_KEY, 'verified');
                resolve(true);
                return true;
              } else {
                this.presentErrorToast('❌ Invalid password. Please try again.');
                // Return false to keep the alert open
                return false;
              }
            }
          }
        ],
        backdropDismiss: false,
        cssClass: 'modern-dev-alert'
      }).then(alert => alert.present());
    });
  }

  private async presentErrorToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color: 'danger',
      position: 'top'
    });
    await toast.present();
  }

  clearAuth() {
    sessionStorage.removeItem(this.SESSION_KEY);
  }
} 